import { render, staticRenderFns } from "./EventRequiresStripeAction.vue?vue&type=template&id=6c4020d7"
import script from "./EventRequiresStripeAction.vue?vue&type=script&lang=js"
export * from "./EventRequiresStripeAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports